<template>
  <div>
      <!-- :key="$route.fullPath 用于相同路由不同传参时，识别路由的区别，从而正确的跳转，不过好像会有性能问题 -->
      <!-- <router-view :key="$route.fullPath"></router-view> -->
      <!-- 下面用于设置导航路径展示 -->
      <!-- <el-breadcrumb v-show="$route.path != '/'" separator-class="el-icon-arrow-right">
        <span class="line">|</span>
        <el-breadcrumb-item>心理测评</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: $route.path }">{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb> -->
      <!-- <div style="width:200px;background-color:#F0F9EB;overflow-y:auto;"> -->
      <div style="width:200px;background-color:#F4F4F5;overflow-y:auto;">
        <!-- <el-menu :default-active="activeIndex" @select="handleSelect" background-color="#F0F9EB" text-color="#606266" active-text-color="#FFD04B" :default-openeds=menu_indexs style="margin-top:30px;" router=true> -->
        <el-menu :default-active="activeIndex" @select="handleSelect" background-color="#F4F4F5" text-color="#606266" active-text-color="#fdb933" :default-openeds=menu_indexs style="margin-top:30px;" router=true>
            <el-submenu index="1">
                <template slot="title">管理后台</template>
                <el-menu-item index="/glyf_mgmt/user_mgmt">用户管理</el-menu-item>
                <el-menu-item index="/glyf_mgmt/painspot_mgmt">痛点管理</el-menu-item>
                <!-- <el-menu-item index="/glyf_mgmt/audit_center">审核中心</el-menu-item> -->
                <el-submenu index="2" class="sub_menu">
                  <template slot="title">审核中心</template>
                  <el-menu-item index="/glyf_mgmt/question_review">用户提问</el-menu-item>
                  <el-menu-item index="/glyf_mgmt/amendment_review">专家修改</el-menu-item>
                  <el-menu-item index="/glyf_mgmt/expert_approve">专家申请</el-menu-item>
                </el-submenu>
            </el-submenu>
        </el-menu>
      </div>
      <div style="flex:1;overflow-y:auto;">
        <router-view></router-view>
      </div>
  </div>
</template>

<script>
import getdata from "@/api/getData.js";
export default {
  created(){
      // 从后台获取用户类型，以便按照用户类型展示对应的菜单项
      let params = {
          task_type: "GLYF",
      }
      getdata.getListP("checklogin", params)
            .then(resp => {
                  if(resp.data.usertype!='admin'){
                    this.$router.push({
                      path: '/glyf_login',
                    });
                  }
            })
            .catch(() => {
                  this.$router.push({
                    path: '/glyf_login',
                  });
            })
      this.activeIndex = this.$route.path; 
  },
  data() {
    return {
      menu_indexs: ['/glyf_mgmt/user_mgmt', '/glyf_mgmt/painspot_mgmt', '/glyf_mgmt/audit_center', '/glyf_mgmt/question_review', '/glyf_mgmt/amendment_review', '/glyf_mgmt/expert_approve', '2'],
      activeIndex: '/glyf_mgmt/user_mgmt',
    }
  },
  // watch: {
  //   $route(to, from) {
  //     this.activeIndex = to.path;
  //   }
  // }
}
</script>

<style scoped>
.el-breadcrumb {
  height: 10px;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.line {
  position: absolute;
  color: white;
  border-left: 3px solid red;
  left: 10px;
}
.el-menu {
    border-bottom: none;
}
.el-menu-item {
    font-size: 15px;
    line-height: 40px;
    height: 40px;
    text-align: center;
}
.el-submenu /deep/ .el-submenu__title {
    font-size: 17px;
    line-height: 45px;
    height: 45px;
    text-align: left;
}
.sub_menu /deep/ .el-submenu__title {
    font-size: 15px;
    line-height: 45px;
    height: 45px;
    text-align: center;
    padding: 0 45px;
}
.sub_menu /deep/ .el-menu-item {
    text-align: right;
}
</style>